import { useQuery } from "@tanstack/react-query";
import { authClient, useSession } from "../lib/auth-client";

export interface Subscription {
	id: string;
	plan: string;
	status: string;
	cancelAtPeriodEnd?: boolean;
	cancelAt?: string | null;
	/** Current billing period end — the renewal (or cancellation) date. */
	periodEnd?: string | null;
}

/**
 * Shared subscription state. React Query dedupes the request, so the account
 * identity badge and the subscription section read from one fetch.
 */
export function useSubscriptions() {
	const { data: session } = useSession();
	const userId = session?.user?.id;

	const query = useQuery({
		queryKey: ["subscriptions", userId],
		enabled: !!userId,
		queryFn: async () => {
			const result = await authClient.subscription.list();
			return (result.data ?? []) as Subscription[];
		},
	});

	const subscriptions = query.data ?? [];
	const activeSub = subscriptions.find((s) => s.status === "active" || s.status === "trialing") ?? null;

	// Only the Pro plan unlocks the Konsoll (and API access). Basic subscribers
	// have an active subscription but are treated as non-Pro for gating.
	const isPro = (activeSub?.plan ?? "").toLowerCase() === "pro";

	return {
		subscriptions,
		activeSub,
		isPro,
		isLoading: !!userId && query.isLoading,
	};
}
